<template>
  <div class="task-assigner">
    <volunteers-selector @onSubmit="onPublishTask" btn-label="حفظ التغيرات" />
  </div>
</template>

<script>
import { RepositoryFactory } from "../volunteer-repositories/volunteerRepositoryFactory";
import VolunteersSelector from "@/app/volunteer/components/VolunteersSelector.vue";

const tasksRepo = RepositoryFactory.get("tasksRepository");

export default {
  name: "TaskAssigner",
  components: {
    VolunteersSelector,
  },
  data() {
    return {
      permissions: {
        // add: 'tasks_management',
        // edit: 'tasks_management',
        // delete: 'tasks_management',
      }
    };
  },
  methods: {
    async onPublishTask(payload) {
      const taskId = this.$route.params.id;
      const _payload = {
        excludedVolunteerIds: payload.excludedVolunteer
      };
      return await tasksRepo.publishTask(
        {
          taskId,
          payload: _payload,
          query: payload.query
        }
      );
    },
  },
};
</script>
